import React from 'react';
import {
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

type RangeKey = '7d' | '30d' | 'all';

type Props = {
  search: string;
  onSearch: (value: string) => void;
  range: RangeKey;
  onRangeChange: (value: RangeKey) => void;
  optInOnly: boolean;
  onOptInToggle: (value: boolean) => void;
  rangeLabel: string;
  placeholders: {
    search: string;
    last7: string;
    last30: string;
    all: string;
    optIn: string;
  };
};

const FilterRow: React.FC<Props> = ({
  search,
  onSearch,
  range,
  onRangeChange,
  optInOnly,
  onOptInToggle,
  rangeLabel,
  placeholders,
}) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    spacing={1.5}
    alignItems={{ xs: 'stretch', md: 'center' }}>
    <TextField
      fullWidth
      size="small"
      placeholder={placeholders.search}
      value={search}
      onChange={e => onSearch(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FilterAltIcon fontSize="small" sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
      }}
    />
    <TextField
      select
      size="small"
      label={rangeLabel}
      value={range}
      onChange={e => onRangeChange(e.target.value as RangeKey)}
      sx={{ minWidth: 160 }}>
      <MenuItem value="7d">{placeholders.last7}</MenuItem>
      <MenuItem value="30d">{placeholders.last30}</MenuItem>
      <MenuItem value="all">{placeholders.all}</MenuItem>
    </TextField>
    <FormControlLabel
      control={
        <Switch checked={optInOnly} onChange={(_, v) => onOptInToggle(v)} />
      }
      label={placeholders.optIn}
    />
  </Stack>
);

export { FilterRow };
